/* eslint @typescript-eslint/naming-convention: 0 */

import type { ReservationSectionId } from '@/wabunka-src/common/features/Reservation/core/requiredFields/sections';
import { buildReservationSectionParams, type ReservationSectionParams } from '@/wabunka-src/common/utils/googleAnalytics/common/reservationSection';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface ReservationSectionCompleteParams extends ReservationSectionParams {
  /** Continue を押さずに自動完了したときだけ付ける（D-038） */
  reservation_section_auto_completed?: true;
}

/** 発火タイミング：新動線でセクションを通過したとき（Continue・自動完了とも 1 セクション 1 回）。着地時点で通過済みのセクションと、Continue の無い S4 では発火しない */
export const sendGAWabunkaReservationSectionCompleteEvent = (sectionId: ReservationSectionId, isAutoCompleted: boolean) => {
  sendWabunkaGAEvent('reservation_section_complete', { ...buildReservationSectionParams(sectionId), ...(isAutoCompleted ? { reservation_section_auto_completed: true } : {}) });
};
